import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import { DolaThemeProps } from '../../styles/types'
import { borderRadius, borderWidth } from '../../styles/variables'
import buttonTheme from '../Button/styles/theme'

const theme = {
  dark: {
    arrow: '#2D186C',
    background: buttonTheme.dark.primary.background,
    text: '#FFFFFF',
  },
  light: {
    arrow: '#FFFFFF',
    background: buttonTheme.light.secondary.background,
    text: '#000000',
  },
}

export const Wrapper = styled.span`
  display: inline-block;
  position: relative;
  cursor: pointer;

  &:hover {
    .tooltip {
      display: inline-block;

      ${iPadDown} {
        display: none;
      }
    }
  }
`

export const Content = styled.span`
  font-weight: 400;
  font-size: 0.8vw;
`

export const Subtitle = styled.span`
  padding: 0 0.425vw 0.25vw;
  font-size: 0.94vw;
`

interface StyledToolTipProps extends DolaThemeProps {
  isShort: boolean
  isCaretCenter: boolean
  isCaretLeft: boolean
}

export const StyledToolTip = styled.span<StyledToolTipProps>`
  position: absolute;
  filter: drop-shadow(
    -0.3vw 0.4vw 0vw ${({ dolaTheme }) => buttonTheme[dolaTheme].secondary.border}
  );
  font-size: 0.78vw;
  border-color: ${({ dolaTheme }) => buttonTheme[dolaTheme].secondary.border};
  border-style: solid;
  bottom: 3vw;
  left: -1.6vw;
  padding: 0.75vw;
  background: ${({ dolaTheme }) => theme[dolaTheme].background};
  color: ${({ dolaTheme }) => theme[dolaTheme].text};
  display: none;
  transform: translate(0.3vw, -0.3vw);
  z-index: 10;
  line-height: 1.5;
  width: ${({ isShort }) => (isShort ? 'auto' : '22vw')};
  ${borderWidth};
  ${borderRadius};

  &::after {
    content: '';
    position: absolute;
    bottom: -0.4vw;
    border-width: 0.63vw 0.63vw 0;
    border-style: solid;
    border-color: ${({ dolaTheme }) => theme[dolaTheme].arrow} transparent;
    display: block;
    width: 0;
    z-index: 10;
    ${({ isCaretCenter, isCaretLeft, dolaTheme }) =>
      isCaretCenter
        ? `
      filter: drop-shadow(0vw 0.3vw 0vw ${buttonTheme[dolaTheme].secondary.border});
      left: 43%;
    `
        : isCaretLeft
        ? `
      left: 1.4vw;
      filter: drop-shadow(0vw 0.3vw 0vw ${buttonTheme[dolaTheme].secondary.border});
    `
        : `
    right: 1.4vw;
      filter: drop-shadow(0vw 0.3vw 0vw ${buttonTheme[dolaTheme].secondary.border});
    `};
  }
`
